import { render, staticRenderFns } from "./modal-wrapper.vue?vue&type=template&id=47e56a60&"
import script from "./modal-wrapper.vue?vue&type=script&lang=js&"
export * from "./modal-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./modal-wrapper.vue?vue&type=style&index=0&id=47e56a60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports